import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'; // Import HttpClientModule and provideHttpClient
import { RouterModule, Routes } from '@angular/router';
import { ROOT_LEVEL_MODULES } from './app/core/constants';
import { 
  TranslationLoaderService,
} from './app/core/services';
import { provideStates, provideStore } from '@ngxs/store';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { AuthState} from './app/core/ngxs/actions/auth.states';
import { MembershipState } from './app/core/ngxs/actions/membership.states';
import { AppointmentState } from './app/core/ngxs/actions/appointment.states';
import { TokenInterceptor } from './app/core/interceptors';
import { provideToastr } from 'ngx-toastr';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { AppModeState } from './app/core/ngxs/actions/app-mode.state';
import {routes} from '@routesPath/routes'
import 'zone.js';
import { environment } from '@src/environments/environment';

// ========== Google Tag Manager ==========
(function loadGTM() {
  const gtm = environment.gtm;

  if (!gtm?.enabled || !gtm.id) {
    return;
  }

  const script = document.createElement('script');
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtm.id}');
  `;
  document.head.prepend(script); 
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${gtm.id}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;

  if (document.body) {
    document.body.prepend(noscript);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      document.body.prepend(noscript);
    });
  }
})();
// ========== End Google Tag Manager ==========

const script = document.createElement('script');
script.src = `https://www.google.com/recaptcha/api.js?render=${environment.recaptchaSiteKey}`;
script.async = true;
document.head.appendChild(script);

const scriptPayment = document.createElement('script');
scriptPayment.src = environment.paymentScriptUrl;
scriptPayment.async = true;
document.head.appendChild(scriptPayment);


//  * You don't need appConfig.providers since we are doing it directly in the bootstrapApplication
// import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, { // Pass an object with providers
  providers: [
    provideToastr(), // Toastr providers
    provideStore([],withNgxsStoragePlugin({
        keys: '*'
      })),
      withNgxsStoragePlugin({ keys: '*' }), 
      withNgxsReduxDevtoolsPlugin({
      disabled: false, // set to true in production if you want to disable
      maxAge: 25,       // keep the last 25 states in history
      }),
       // 👇 Register NGXS and your states here
    provideStates([AuthState,MembershipState,AppointmentState,AppModeState]),
    TranslationLoaderService,
    importProvidersFrom(RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })),
    importProvidersFrom(HttpClientModule,...ROOT_LEVEL_MODULES), // Import HttpClientModule providers
    provideHttpClient(withInterceptorsFromDi()), // Add this for modern HttpClient features
     { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ]
})
  .catch((err) => console.error(err));
